var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography, Accordion, AccordionSummary, AccordionDetails, AccordionActions } from '@mui/material';
import useStyles from './styles';
const ExtensivAccordion = (props) => {
    const { summary, details, actions, summaryProps = {}, detailsProps = {}, actionProps = {}, className, dataTestId } = props, accordionProps = __rest(props, ["summary", "details", "actions", "summaryProps", "detailsProps", "actionProps", "className", "dataTestId"]);
    const cmpSelector = dataTestId || 'ExtensivAccordion';
    const { classes, cx } = useStyles();
    const renderAccordionSummary = () => {
        if (typeof summary === 'function') {
            return summary(summaryProps, props);
        }
        return _jsx(Typography, Object.assign({ fontWeight: 700 }, { children: summary }));
    };
    const renderAccordionDetails = () => {
        if (typeof details === 'function') {
            return details(detailsProps, props);
        }
        return details;
    };
    const renderAccordionActions = () => {
        if (typeof actions === 'function') {
            return actions(actionProps, props);
        }
        return actions;
    };
    return (_jsxs(Accordion, Object.assign({ className: cx(classes.extensivAccordion, className), "data-testid": `${cmpSelector}` }, accordionProps, { children: [_jsx(AccordionSummary, Object.assign({ expandIcon: _jsx(FontAwesomeIcon, { icon: faChevronDown, size: 'lg' }), "data-testid": `${cmpSelector}Summary` }, summaryProps, { children: renderAccordionSummary() })), (details !== undefined && details !== null) && (_jsx(AccordionDetails, Object.assign({ "data-testid": `${cmpSelector}Details` }, detailsProps, { children: renderAccordionDetails() }))), (actions !== undefined && actions !== null) && (_jsx(AccordionActions, Object.assign({ "data-testid": `${cmpSelector}Actions` }, actionProps, { children: renderAccordionActions() })))] })));
};
export default ExtensivAccordion;
//# sourceMappingURL=index.js.map